export default "__VITE_ASSET__DKWTWaqZ__"